var _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 118,
    viewBox: "0 0 68 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_36_3460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9987 33.694C29.2421 36.9698 37.8695 46.0173 40.6054 57.4046L43.0052 67.388L45.4051 57.4046C48.1409 46.0173 56.7684 36.9698 68.0118 33.694C56.7564 30.4182 48.1289 21.3707 45.3931 9.99541L42.9932 0L40.5934 9.99541C37.8695 21.3707 29.2421 30.4182 17.9987 33.694Z",
    fill: "#EAE6DC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_36_3460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 92.3901C8.36437 94.8395 14.7827 101.605 16.818 110.119L18.6034 117.584L20.3887 110.119C22.424 101.605 28.8424 94.8395 37.2067 92.3901C28.8334 89.9407 22.4151 83.1756 20.3798 74.6699L18.5944 67.196L16.8091 74.6699C14.7827 83.1756 8.36437 89.9407 0 92.3901Z",
    fill: "#EAE6DC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_36_3460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.0011,
    height: 67.4,
    fill: "white",
    transform: "translate(17.9987)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_36_3460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.1978,
    height: 50.397,
    fill: "white",
    transform: "translate(0 67.196)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.462261e62b3f92a6614d919facc4d5f3.svg";
export { ForwardRef as ReactComponent };